import { useState, useEffect } from 'react'
import { Tab } from 'components'
import { useMenurecipInfo, useMenurecipCombo } from 'api/menucrte/menurecip-fetch'
import { userInfoState } from 'store/atom/user-state-atom'
import { useRecoilValue } from 'recoil'
import MenuRecipSite from './MenuRecipSite'
import MenuRecipStd from './MenuRecipStd'
import MenuRecipCook from './MenuReciptCook'
import MenuRecipKnow from './MenuReciptKnow'
import { queryClient } from 'index'

// css
import 'assets/style/common.scss'

/**
{
  siteId: null,
  menuId: 'M12072',
  menuSeq: 0,
}
 * @param {*} param0 
 * @returns 
 */
function MenuRecip({ info = {} }) {
  console.log(info)
  const userInfo = useRecoilValue(userInfoState)
  const tabDefault = [
    { id: '1', text: '사이트레시피', active: true },
    { id: '2', text: '표준레시피', active: false },
    { id: '3', text: '조리법', active: false },
    { id: '4', text: '노하우', active: false },
  ]

  const [isInit, setIsInit] = useState(false)
  const [isInit2, setIsInit2] = useState(false)
  const [tab, setTab] = useState(tabDefault)
  const [params, setParams] = useState()
  const defaultParam = {
    ...info,
    coId: userInfo.coId,
    userId: userInfo.userId,
    mySiteId: userInfo.siteId,
    skip: 'N',
  }

  const { data: combo } = useMenurecipCombo(defaultParam, isInit)
  const { data, isSuccess, refetch } = useMenurecipInfo(params, isInit2)

  useEffect(() => {
    setIsInit(true)
    return () => {
      queryClient.removeQueries('menurecipInfo')
      queryClient.removeQueries('menurecipCombo')
    }
  }, [])

  useEffect(() => {
    if (data?.recipType === 'STD') {
      clickTab('2')
    }
  }, [isSuccess])

  useEffect(() => {
    if (combo) {
      setParam(0)
    }
  }, [combo])

  useEffect(() => {
    if (params) {
      refetch()
    }
  }, [params])

  const setParam = (index) => {
    const temp = combo?.menuIdList[index].menuIdSeq.split('|')
    const menuId = temp[0]
    const menuSeq = temp[1]
    const siteId = temp[2]
    const siteType = temp[3]

    let tempParams = {
      coId: userInfo.coId,
      userId: userInfo.userId,
      shpId: userInfo.shpId,
      siteId: siteId,
      menuId: menuId,
      menuSeq: menuSeq,
      mySiteId: siteType === 'M' ? siteId : userInfo.siteId,
      myLgsCtrId: siteType === 'M' ? null : userInfo.lgsCtrId,
      searchMenuId: combo?.menuIdList[index].menuIdSeq,
      skip: 'Y',
      myRecipeYn: 'N',
    }
    setParams(() => tempParams)
  }

  const clickTab = (id) => {
    setTab((prev) => {
      return prev.map((item) => {
        item.active = false
        item.active = item.id === id
        return item
      })
    })
  }

  const changeSiteRecip = (e) => {
    setParam(e.target.selectedIndex)
  }

  return (
    <main>
      {/* todo: 팝업헤더 */}
      <Tab data={tab} clickTab={clickTab} />
      <div className="position menu-recipep-1" style={tab[0]?.active ? { display: 'block' } : { display: 'none' }}>
        <MenuRecipSite
          dataList={data?.recipType === 'STD' ? data?.stdRecipList : data?.steRecipList}
          imgList={data?.menuRecipImageManageList}
          siteRecipCombo={combo?.menuIdList}
          onChange={changeSiteRecip}
          recipType={data?.recipType}
        />
      </div>
      <div className="position" style={tab[1]?.active ? { display: 'block' } : { display: 'none' }}>
        <MenuRecipStd
          dataList={data?.stdRecipList}
          imgList={data?.menuRecipImageManageList}
          menuInfo={data?.menuInfoMap}
        />
      </div>
      <div style={tab[2]?.active ? { display: 'block' } : { display: 'none' }}>
        <MenuRecipCook dataList={data?.menuCokWayList} />
      </div>
      <div className="menu-recipep-4 wrapper mt16" style={tab[3]?.active ? { display: 'block' } : { display: 'none' }}>
        <MenuRecipKnow dataList={data?.menuOperKnowhowList} />
      </div>
    </main>
  )
}

export default MenuRecip
